import axios, {AxiosResponse} from 'axios'
import {ApiResponse, PageResponse} from '../../../../shared/models/ApiModels'
import {ICarMTVModel} from './CarMTVModel'

const API_URL = (process.env.REACT_APP_API_URL || '/').replace(/\/?$/, '/')

export const CAR_MTV_CREATE_URL = `${API_URL}api/v1/car/mtv/create`
export const CAR_MTV_GET_ALL_URL = `${API_URL}api/v1/car/mtv/all`
export const CAR_MTV_DELETE_URL = `${API_URL}api/v1/car/mtv/delete/`
export const CAR_MTV_UPDATE_URL = `${API_URL}api/v1/car/mtv/update/`

export function createCarMTV(carMTV: ICarMTVModel) {
  return axios.post(CAR_MTV_CREATE_URL, carMTV)
}

export async function loadCarMTV(
  page = 0,
  size = 5,
  sort: string = 'createdDate',
  order: string = 'desc'
): Promise<AxiosResponse<ApiResponse<PageResponse<ICarMTVModel>>>> {
  return axios.get(CAR_MTV_GET_ALL_URL, {
    params: {page, size, sort, order},
  })
}

export function deleteCarMTV(carMTVId: String) {
  return axios.delete(CAR_MTV_DELETE_URL + carMTVId)
}

export function updateCarMTV(carMTV: ICarMTVModel) {
  return axios.patch(CAR_MTV_UPDATE_URL + carMTV.id, carMTV)
}
